<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <div style="float: left; position: relative; width: 70%; border-collapse: collapse; text-align: left">
                    <h4 class="m-b-0 text-white">Solicitudes de apoyo</h4>
                </div>
            </div>
            <div class="card-body" id="padre">
                <!-- ========================= -->
                <!-- ===== Primera tabla ===== -->
                <!-- ========================= -->
                <div>
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Id</th>
                                <th>Obra</th>
                                <th>Estatus</th>
                                <th>Sucursal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orden of ordenes" style="text-align: center" (click)="ordenSeleccionada(orden)">
                                <td>{{ orden.ordenTrabajoId }}</td>
                                <td>{{ orden.obra }}</td>
                                <td> <span class="label" [style.background]="orden.estatusDos.color">  {{ orden.estatusDos.nombre }} </span></td>
                                <td>{{ orden.sucursalNombre }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- ========================= -->
                <!-- ===== Primera tabla ===== -->
                <!-- ========================= -->
                <!-- ========================= -->
                <!-- ===== Segunda tabla ===== -->
                <!-- ========================= -->
                <!--
                <div>
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger2" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Id</th>
                                <th>Obra</th>
                                <th>Estatus</th>
                                <th>Sucursal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let apoyo of arrayApoyosSolicitados" style="text-align: center" (click)="apoyoSolicitado(apoyo)">
                                <td>{{ apoyo.ordenTrabajoId }}</td>
                                <td>{{ apoyo.obra }}</td>
                                <td> <span class="label" [style.background]="apoyo.estatusDos.color">  {{ apoyo.estatusDos.nombre }} </span></td>
                                <td>{{ apoyo.sucursalNombre }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                -->
                <!-- ========================= -->
                <!-- ===== Segunda tabla ===== -->
                <!-- ========================= -->
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/listar-apoyo-traspaso/listar-apoyo-traspaso.component.html